<div class="SLV2-stroiesbnner-box">
    <h3 class="SLV2-stroiesbnner-title">
        <img class="icon-img" src="selflearnv2-ui/assets/img/self-learn-v2/stories-book-icon.svg" />
        <span>E-Lessons</span>
    </h3>

    <p class="SLV2-stroiesbnner-text">Explore new and interactive ways to revise your concepts</p>

    <button class="SLV2-prctcs-solid-button" (click)="openStoriesDialog()">Open E-Lessons</button>
</div>